import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { FlightLogActions, FlightLogActionTypes } from './flight-log.actions';
import { FlightLogEntity } from './flight-log.model';

export interface FlightLogEntities extends EntityState<FlightLogEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FlightLogEntity> = createEntityAdapter<FlightLogEntity>();

export const initialState: FlightLogEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): FlightLogEntities {
  const action: FlightLogActions = incomingAction as FlightLogActions;
  switch (action.type) {
    case FlightLogActionTypes.AddFlightLog: {
      return adapter.addOne(action.payload.flightLog, state);
    }

    case FlightLogActionTypes.UpsertFlightLog: {
      return adapter.upsertOne(action.payload.flightLog, state);
    }

    case FlightLogActionTypes.AddFlightLogs: {
      return adapter.addMany(action.payload.flightLogs, state);
    }

    case FlightLogActionTypes.UpsertFlightLogs: {
      return adapter.upsertMany(action.payload.flightLogs, state);
    }

    case FlightLogActionTypes.UpdateFlightLog: {
      return adapter.updateOne(action.payload.flightLog, state);
    }

    case FlightLogActionTypes.UpdateFlightLogs: {
      return adapter.updateMany(action.payload.flightLogs, state);
    }

    case FlightLogActionTypes.DeleteFlightLog: {
      return adapter.removeOne(action.payload.id, state);
    }

    case FlightLogActionTypes.DeleteFlightLogs: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case FlightLogActionTypes.LoadFlightLogs: {
      return adapter.setAll(action.payload.flightLogs, state);
    }

    case FlightLogActionTypes.ClearFlightLogs: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
